import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "../components/site/Reveal";
import { Seo } from "../components/site/Seo";

export default function Styles() {
  const { data: styles = [] } = useQuery({ queryKey: ["styles"], queryFn: async () => (await api.get("/styles")).data });

  return (
    <>
      <Seo title="Tattoo Styles" description="The disciplines of Obsidian Art & Tattoo Studio — black & grey, realism, fine line, traditional, neo-traditional, color, anime, blackwork, gothic, Polynesian, lettering, floral, illustrative and custom." />
      <section className="pt-36 lg:pt-44 pb-16 max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 border-b border-ash">
        <Reveal><p className="eyebrow mb-6">Disciplines</p></Reveal>
        <Reveal delay={60}><h1 className="display text-6xl sm:text-7xl lg:text-8xl text-white">Styles.</h1></Reveal>
        <Reveal delay={120}><p className="mt-8 max-w-xl text-[#9E9EA8] text-lg">Fourteen disciplines under one roof. Find the language your idea should be spoken in.</p></Reveal>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        {styles.map((s, i) => (
          <Reveal key={s.slug}>
            <Link to={`/styles/${s.slug}`} data-testid={`style-row-${s.slug}`} className="group flex items-center justify-between gap-6 py-10 lg:py-14 border-b border-ash">
              <div className="flex items-baseline gap-6 lg:gap-12">
                <span className="font-mono text-xs text-[#828290] tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h2 className="display text-4xl lg:text-7xl text-[#C4C4CC] group-hover:text-white transition-colors">{s.name}</h2>
                  <p className="mt-3 max-w-xl text-[#828290] text-sm lg:text-base hidden sm:block">{s.blurb}</p>
                </div>
              </div>
              <ArrowUpRight className="text-[#828290] group-hover:text-ember group-hover:translate-x-1 group-hover:-translate-y-1 transition-all shrink-0" size={32} />
            </Link>
          </Reveal>
        ))}
      </section>
    </>
  );
}
